export default __webpack_public_path__ + "static/media/logo.ea678db9.png";